import {
  pgTable,
  text,
  timestamp,
  uuid,
  integer,
  index,
  uniqueIndex,
  unique,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

const tz = { withTimezone: true } as const;

export const retentionPolicies = pgTable(
  "retention_policies",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    dataCategory: text("data_category").notNull(),
    retentionDays: integer("retention_days").notNull(),
    legalBasis: text("legal_basis").notNull(),
    appliesToTable: text("applies_to_table").notNull(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    uniqueIndex("uq_retention_tenant_category_table").on(
      table.tenantId,
      table.dataCategory,
      table.appliesToTable,
    ),
    index("idx_retention_policies_tenant").on(table.tenantId),
  ],
);

export const legalHolds = pgTable(
  "legal_holds",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    holdName: text("hold_name").notNull(),
    reason: text("reason").notNull(),
    scope: text("scope").notNull(),
    targetIds: text("target_ids").array().notNull(),
    createdBy: text("created_by").notNull(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    releasedAt: timestamp("released_at", tz),
    releasedBy: text("released_by"),
  },
  (table) => [
    index("idx_legal_holds_tenant").on(table.tenantId),
    index("idx_legal_holds_tenant_active")
      .on(table.tenantId)
      .where(sql`released_at IS NULL`),
  ],
);

export const erasureRequests = pgTable(
  "erasure_requests",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    personId: uuid("person_id").notNull(),
    status: text("status").notNull().default("pending"),
    anonymizationToken: text("anonymization_token"),
    fieldsAnonymized: integer("fields_anonymized").notNull().default(0),
    tablesProcessed: text("tables_processed")
      .array()
      .notNull()
      .default(sql`'{}'::text[]`),
    errorMessage: text("error_message"),
    requestedBy: text("requested_by").notNull(),
    completedAt: timestamp("completed_at", tz),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_erasure_requests_tenant").on(table.tenantId),
    index("idx_erasure_requests_status").on(table.status),
    index("idx_erasure_requests_tenant_person").on(
      table.tenantId,
      table.personId,
    ),
    // Task 11.16: Partial unique index enforced at DB level via raw migration
    // (0009_erasure_active_request_unique.sql). Prevents concurrent active
    // erasure requests for the same person. Re-erasure after completion is allowed.
    // Application-level check in erasure-service.requestErasure() provides
    // clean UX; DB index is the TOCTOU safety net.
  ],
);
